import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hidden min-w-0 border-r border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900 md:block" }
const _hoisted_2 = { class: "flex gap-2 p-2 md:flex-col" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = {
  key: 1,
  class: "fixed inset-y-0 left-0 z-50 w-[min(18rem,85vw)] border-r border-slate-200 bg-white shadow-2xl dark:border-slate-700 dark:bg-slate-900 md:hidden"
}
const _hoisted_5 = { class: "flex h-14 items-center justify-between border-b border-slate-200 px-4 dark:border-slate-700" }
const _hoisted_6 = { class: "flex flex-col gap-2 p-2" }

import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import {
  ActivityIcon,
  AlertTriangleIcon,
  Building2Icon,
  FilesIcon,
  HospitalIcon,
  LayoutDashboardIcon,
  MenuIcon,
  MessageCircleIcon,
  BellRingIcon,
  SettingsIcon,
  UsersIcon,
  XIcon,
} from "@lucide/vue";

const navigationItemClass =
  "inline-flex h-10 w-full min-w-10 items-center gap-2 rounded-md border px-3 text-sm font-medium shadow-sm transition focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-500";
const inactiveNavigationItemClass =
  "border-slate-200 bg-white text-slate-700 hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:border-blue-700 dark:hover:bg-blue-950/40 dark:hover:text-blue-200";
const activeNavigationItemClass =
  "border-blue-500 bg-blue-50 text-blue-700 shadow-none hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 dark:border-blue-400 dark:bg-blue-950/70 dark:text-blue-100 dark:hover:border-blue-400 dark:hover:bg-blue-950/70 dark:hover:text-blue-100";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainSidebar',
  props: {
    canViewSystem: { type: Boolean },
    canViewOperatingRooms: { type: Boolean },
    canViewAdverseEvents: { type: Boolean },
    canManageDepartments: { type: Boolean },
    canManageNotificationSettings: { type: Boolean },
    canViewUsers: { type: Boolean }
  },
  setup(__props: any) {



const route = useRoute();
const isMobileMenuOpen = ref(false);

function getNavigationItemClass(routeNames: string[]): string[] {
  const isActive =
    typeof route.name === "string" && routeNames.includes(route.name);
  return [
    navigationItemClass,
    isActive ? activeNavigationItemClass : inactiveNavigationItemClass,
  ];
}

watch(
  () => route.fullPath,
  () => {
    isMobileMenuOpen.value = false;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", _hoisted_1, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex h-14 items-center border-b border-slate-200 px-4 dark:border-slate-700" }, [
        _createElementVNode("div", { class: "text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400" }, " Панель ")
      ], -1)),
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(getNavigationItemClass(['home'])),
          to: { name: 'home' }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(LayoutDashboardIcon), {
              class: "h-4 w-4 shrink-0",
              "aria-hidden": "true"
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "truncate" }, "Панель", -1))
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(getNavigationItemClass(['chat'])),
          to: { name: 'chat' }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MessageCircleIcon), {
              class: "h-4 w-4 shrink-0",
              "aria-hidden": "true"
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "truncate" }, "Чат", -1))
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(
          getNavigationItemClass([
            'files',
            'files-my',
            'files-user',
            'files-document',
          ])
        ),
          to: { name: 'files' }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FilesIcon), {
              class: "h-4 w-4 shrink-0",
              "aria-hidden": "true"
            }),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "truncate" }, "Файлы", -1))
          ]),
          _: 1
        }, 8, ["class"]),
        (__props.canViewOperatingRooms)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(
          getNavigationItemClass([
            'operating-rooms',
            'operating-room',
            'operating-room-operation',
          ])
        ),
              to: { name: 'operating-rooms' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Building2Icon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "truncate" }, "Операционные", -1))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (__props.canViewAdverseEvents)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: _normalizeClass(getNavigationItemClass(['adverse-events'])),
              to: { name: 'adverse-events' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(AlertTriangleIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "truncate" }, "События", -1))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (__props.canManageDepartments)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              class: _normalizeClass(getNavigationItemClass(['departments'])),
              to: { name: 'departments' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(HospitalIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "truncate" }, "Отделения", -1))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (__props.canViewUsers)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              class: _normalizeClass(getNavigationItemClass(['users'])),
              to: { name: 'users' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UsersIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "truncate" }, "Пользователи", -1))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (__props.canManageNotificationSettings)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 4,
              class: _normalizeClass(getNavigationItemClass(['notification-settings'])),
              to: { name: 'notification-settings' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BellRingIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "truncate" }, "Настройки уведомлений", -1))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (__props.canViewSystem)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 5,
              class: _normalizeClass(getNavigationItemClass(['system', 'system-package-logs'])),
              to: { name: 'system' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ActivityIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "truncate" }, "Система", -1))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          class: _normalizeClass(getNavigationItemClass(['settings'])),
          to: { name: 'settings' }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SettingsIcon), {
              class: "h-4 w-4 shrink-0",
              "aria-hidden": "true"
            }),
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "truncate" }, "Настройки", -1))
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("button", {
      class: "fixed left-3 top-2.5 z-20 inline-flex h-9 w-9 items-center justify-center rounded-md border border-slate-300 bg-white text-slate-700 shadow-sm transition hover:bg-slate-50 focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-500 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800 md:hidden",
      type: "button",
      "aria-expanded": isMobileMenuOpen.value,
      "aria-label": "Открыть навигацию",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isMobileMenuOpen.value = true))
    }, [
      _createVNode(_unref(MenuIcon), {
        class: "h-5 w-5",
        "aria-hidden": "true"
      })
    ], 8, _hoisted_3),
    (isMobileMenuOpen.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "fixed inset-0 z-40 bg-slate-950/40 backdrop-blur-[1px] md:hidden",
          type: "button",
          "aria-label": "Закрыть навигацию",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isMobileMenuOpen.value = false))
        }))
      : _createCommentVNode("", true),
    (isMobileMenuOpen.value)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400" }, " Навигация ", -1)),
            _createElementVNode("button", {
              class: "inline-flex h-9 w-9 items-center justify-center rounded-md text-slate-600 transition hover:bg-slate-100 focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-500 dark:text-slate-300 dark:hover:bg-slate-800",
              type: "button",
              "aria-label": "Закрыть навигацию",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (isMobileMenuOpen.value = false))
            }, [
              _createVNode(_unref(XIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ])
          ]),
          _createElementVNode("nav", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(getNavigationItemClass(['home'])),
              to: { name: 'home' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(LayoutDashboardIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "truncate" }, "Панель", -1))
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              class: _normalizeClass(getNavigationItemClass(['chat'])),
              to: { name: 'chat' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(MessageCircleIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "truncate" }, "Чат", -1))
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              class: _normalizeClass(
          getNavigationItemClass([
            'files',
            'files-my',
            'files-user',
            'files-document',
          ])
        ),
              to: { name: 'files' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FilesIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "truncate" }, "Файлы", -1))
              ]),
              _: 1
            }, 8, ["class"]),
            (__props.canViewOperatingRooms)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: _normalizeClass(
          getNavigationItemClass([
            'operating-rooms',
            'operating-room',
            'operating-room-operation',
          ])
        ),
                  to: { name: 'operating-rooms' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Building2Icon), {
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }),
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "truncate" }, "Операционные", -1))
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (__props.canViewAdverseEvents)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: _normalizeClass(getNavigationItemClass(['adverse-events'])),
                  to: { name: 'adverse-events' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AlertTriangleIcon), {
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }),
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "truncate" }, "События", -1))
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (__props.canManageDepartments)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: _normalizeClass(getNavigationItemClass(['departments'])),
                  to: { name: 'departments' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(HospitalIcon), {
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }),
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "truncate" }, "Отделения", -1))
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (__props.canViewUsers)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  class: _normalizeClass(getNavigationItemClass(['users'])),
                  to: { name: 'users' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UsersIcon), {
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }),
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "truncate" }, "Пользователи", -1))
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (__props.canManageNotificationSettings)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  class: _normalizeClass(getNavigationItemClass(['notification-settings'])),
                  to: { name: 'notification-settings' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BellRingIcon), {
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }),
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "truncate" }, "Настройки уведомлений", -1))
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (__props.canViewSystem)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  class: _normalizeClass(getNavigationItemClass(['system', 'system-package-logs'])),
                  to: { name: 'system' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ActivityIcon), {
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }),
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "truncate" }, "Система", -1))
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              class: _normalizeClass(getNavigationItemClass(['settings'])),
              to: { name: 'settings' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SettingsIcon), {
                  class: "h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "truncate" }, "Настройки", -1))
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})